// Entry point for the esbuild bundle (app/assets/builds/application.js),
// loaded by layouts/_javascripts. Import order is execution order: globals
// must come first so the jQuery plugins and the Propshaft-served scripts
// (admin/admin_app.js, inline view tags) find window.$ / window.I18n.
import "./src/globals";
import "jquery-ujs";
import "foundation-sites/dist/js/foundation";
import "./src/i18n-global";
import "jquery-validation";
import "./vendor/jquery.tagsinput";
import "./vendor/chart";
import "./src/amount_formatter";
import "./src/validators";
import "./src/sepaone_app";
